import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { DBAnalysisData } from '../../../model/analysis-details.model';
import { DBService } from '../../../service/DB.service';
import { StorageService } from '../../../service/storage.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import _moment, { default as _rollupMoment } from 'moment';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/DD/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-previous-data-summary',
  standalone: true,
  imports: [],
  templateUrl: './previous-data-summary.component.html',
  styleUrl: './previous-data-summary.component.scss',
  providers: [{
    provide: DateAdapter,
    useClass: MomentDateAdapter,
    deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
  },
  { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class PreviousDataSummaryComponent implements OnInit, OnDestroy {

  previousAnalysisKeys: DBAnalysisData[] = [];
  pageLoaded = false;
  private dbAnalysisDataSubscription?: Subscription;
  startDate: string | undefined;
  endDate: string | undefined;
  maxDate = new Date();
  auditFlag = false;
  dateRangeStart?: moment.Moment | null;
  dateRangeEnd?: moment.Moment | null;
  userAttributes?: string | null;
  dataCompile: boolean = true;
  displayErrorMessage: boolean = false;
  isLoading: boolean = false;
  errorMessage: string = ''

  @ViewChild('RApaginator', { static: false }) paginator?: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort?: MatSort;
  dataSource?: MatTableDataSource<DBAnalysisData>;
  tableColumns: string[] = ['analyteName', 'analysisType', 'analysisDate', 'projectNames'];
  searchResults: DBAnalysisData[] = [];
  @ViewChild('htmlData1') htmlData1!: ElementRef;

  constructor(
    private dbService: DBService,
    private storageService: StorageService,
  ) { }

  ngOnInit(): void {

    this.userAttributes = this.storageService.get('access');
    if (this.userAttributes == 'PI') {
      this.pageLoaded = false;
    } else if (this.userAttributes == 'GA' || this.userAttributes == 'SU' || this.userAttributes == 'QA') {
      this.isLoading = true;
      this.getPreviousDataSummary(this.userAttributes, this.startDate, this.endDate, this.auditFlag, this.dataCompile);
    }
  }

  getPreviousDataSummary(userAttributes, startDate, endDate, auditFlag, dataCompile) {
    this.dbAnalysisDataSubscription = this.dbService.getAnalysis(userAttributes, startDate, endDate, auditFlag, dataCompile).subscribe({
      next: (data: DBAnalysisData[]) => {
         this.isLoading = false;
        this.previousAnalysisKeys = data;
        this.searchResults = data;
        this.pageLoaded = true;
        this.displayData();
      },
      error: (err) => {
        this.isLoading = false;
        this.displayErrorMessage = true;
        console.log(err)
        switch (err.status) {
          case 400:
            this.errorMessage = "Bad Request. Please verify the input values.";
            break;
          case 401:
            this.errorMessage = "Unauthorized access. Please login again.";
            break;
          case 403:
            this.errorMessage = "Access denied. You do not have permission to perform this action.";
            break;
          case 404:
            this.errorMessage = "No data found for the given criteria.";
            break;
          case 500:
            this.errorMessage = "Server error. Please try again later.";
            break;
          case 502:
            this.errorMessage = "Bad Gateway. The server is temporarily unavailable.";
            break;
          case 503:
            this.errorMessage = "Service Unavailable. Please try again later.";
            break;
          case 504:
            this.errorMessage = "Gateway Timeout. Server took too long to respond.";
            break;
          default:
            this.errorMessage = "Unexpected error occurred. Please try again.";
        }
      }
    }
    );
  }

  displayData() {
    this.dataSource = new MatTableDataSource(this.searchResults);
    setTimeout(() => this.dataSource!.paginator = this.paginator ?? null);
    setTimeout(() => this.dataSource!.sort = this.sort ?? null);

  }


  public openPDF1(): void {
    const DATA: any = document.getElementById('htmlData1');
    html2canvas(DATA).then((canvas) => {
      const fileWidth = 208;
      const fileHeight = (canvas.height * fileWidth) / canvas.width;
      const FILEURI = canvas.toDataURL('image/png');
      const PDF = new jsPDF('p', 'mm', 'a4');
      const position = 0;
      PDF.addImage(FILEURI, 'PNG', 0, position, fileWidth, fileHeight);
      PDF.save('report-analysis.pdf');
    });
  }

  getUrl(analysisType: string) {
    if (analysisType === 'qPCR-Compilation') {
      return '/default-layout/qpcr-molecule-analysis';
    }
    else {
      return '/default-layout/notfound';
    }

  }

  applyFilter(filterValue: string) {
    this.dataSource!.filter = filterValue.trim().toLowerCase();
  }

  selectedDates() {
    this.isLoading = true;
    this.displayErrorMessage = false;
    this.errorMessage = '';
    this.startDate = this.dateRangeStart?.format('MM/DD/YYYY');
    this.endDate = this.dateRangeEnd?.format('MM/DD/YYYY');
    this.previousAnalysisKeys = [];
    this.getPreviousDataSummary(this.userAttributes, this.startDate, this.endDate, this.auditFlag, this.dataCompile);
  }


  clearSelectedDates() {
    this.isLoading = true;
    this.displayErrorMessage = false;
    this.errorMessage = '';
    this.previousAnalysisKeys = [];
    this.dateRangeEnd = null;
    this.dateRangeStart = null;
    this.startDate = 'none';
    this.endDate = 'none';
    this.getPreviousDataSummary(this.userAttributes, this.startDate, this.endDate, this.auditFlag, this.dataCompile);

  }

  ngOnDestroy() {
    if (this.dbAnalysisDataSubscription) {
      this.dbAnalysisDataSubscription.unsubscribe();
    }
  }
}

